import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { i18n, loadPublicMessages } from './setup/i18n'
import { config, loadConfig } from './setup/config'

Vue.config.productionTip = false

/**
 * Some dependencies are stored in public folder to allow users change them
 * without rebuilding the app. This function loads these dependencies only once
 * right before Vue initializing.
 */
function loadPublicDependencies (): Promise<Array<void>> {
  return loadConfig()
    .then(() => loadPublicMessages(config.loadGlobalMessagesForLocales))
}

loadPublicDependencies()
  .then(() => {
    new Vue({
      router,
      i18n,
      render: h => h(App)
    }).$mount('#app')    
  })
